export const merchantStatuses = {
  trial: 'trial',
  active: 'active',
}
